import { Facilities, Search } from "@/types/types";
import styles from "../more-filters-component.module.css";

export default function Orientation({
  t,
  updateSearch,
  filters,
}: {
  t: any;
  updateSearch: <K extends keyof Search>(
    key: K,
    value: Search[K]
  ) => Promise<void>;
  filters: Search;
}) {
  return (
    <div className={`${styles.filterGroup} ${styles.selectors}`}>
      <fieldset className={styles.fieldSet}>
        <legend className={styles.legend}>{t("orientationTitle")}</legend>
        <ul className={styles.orientationGrid}>
          <li>
            <button
              onClick={async (e) => {
                e.preventDefault();
                await updateSearch("north", !filters.north);
              }}
              className={`${styles.facility} ${
                filters.north ? styles.facilityActive : ""
              }`}
              aria-pressed={filters.north}
            >
              {t("north")}
            </button>
          </li>
          <li>
            <button
              onClick={async (e) => {
                e.preventDefault();
                await updateSearch("south", !filters.south);
              }}
              className={`${styles.facility} ${
                filters.south ? styles.facilityActive : ""
              }`}
              aria-pressed={filters.south}
            >
              {t("south")}
            </button>
          </li>
          <li>
            <button
              onClick={async (e) => {
                e.preventDefault();
                await updateSearch("east", !filters.east);
              }}
              className={`${styles.facility} ${
                filters.east ? styles.facilityActive : ""
              }`}
              aria-pressed={filters.east}
            >
              {t("east")}
            </button>
          </li>
          <li>
            <button
              onClick={async (e) => {
                e.preventDefault();
                await updateSearch("west", !filters.west);
              }}
              className={`${styles.facility} ${
                filters.west ? styles.facilityActive : ""
              }`}
              aria-pressed={filters.west}
            >
              {t("west")}
            </button>
          </li>
        </ul>
      </fieldset>
    </div>
  );
}
